export default __webpack_public_path__ + "static/media/goal-url.b004e404.svg";